import { render, staticRenderFns } from "./EndStoragePeriodEadView.vue?vue&type=template&id=fdc5b454&scoped=true&"
import script from "./EndStoragePeriodEadView.vue?vue&type=script&lang=ts&"
export * from "./EndStoragePeriodEadView.vue?vue&type=script&lang=ts&"
import style0 from "./EndStoragePeriodEadView.vue?vue&type=style&index=0&id=fdc5b454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5b454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
